import { types, getEnv, SnapshotOut, Instance } from 'mobx-state-tree';

import { LiveEventStore } from './liveEvent';
import { observable } from 'mobx';
import { ILiveAppEnv } from '../../liveAppEnvironment';
import { ProgressStateModel } from 'eTip--common';

export const FavoriteEventDetailsStore = types
    .model({
        details: types.optional(types.array(LiveEventStore), []),
        layoutColumns: types.maybeNull(types.number)
    })
    .views(self => {
        return {
            get sortedDetails() {
                return self.details.sort((a, b) => (a.order > b.order ? 1 : -1));
            },
            get totalOpenLiveStreams() {
                let total = 0;
                self.details.forEach(evt => { if (evt.liveStream && evt.liveStream.state !== ProgressStateModel.NotInitialized) { total++; } });
                return total;
            }
            ,
            get totalOpenMatchTrackers() {
                let total = 0;
                self.details.forEach(evt => { if (evt.matchTracker && evt.matchTracker.state !== ProgressStateModel.NotInitialized) { total++; } });
                return total;
            }
        }
    })
    .actions(self => {
        const env = getEnv<ILiveAppEnv>(self);

        const initDetails = (ids: number[]): void => {
            self.layoutColumns = 3;
            if (self.details.length > 0) {
                self.details = observable([]);
            }
            ids.forEach(id => addEvent(id));
        }

        const addEvent = (id: number): void => {
            const maxOrder = self.details.length
                ? self.details.reduce((prev, current) => {
                    return (prev && prev.order > current.order) ? prev : current    //look for element with the biggest order
                }).order
                : 0;
            self.details.push(LiveEventStore.create(<SnapshotOut<typeof LiveEventStore>>{ id: id, order: maxOrder + 1 }, env));
        };

        const removeEvent = (id: number): void => {
            let evt = self.details.find(e => e.id === id);
            if (evt) {
                evt.clean();
                self.details.remove(evt);
            }
        };

        const removeAllFavoriteEvents = () => {
            self.details.forEach(evt => { evt.clean(); });
            self.details = observable([]);
        }

        const moveToStart = (id: number): void => {
            const eventToMove = self.details.find(event => event.id === id);

            if (eventToMove.order > 1) {
                const eventToSwitch = self.details.filter(event => event.order < eventToMove.order).reduce((prev, current) => {
                    return (prev.order > current.order) ? prev : current
                })
                const auxOrder = eventToMove.order;
                eventToMove.order = eventToSwitch.order;
                eventToSwitch.order = auxOrder;
            }
        }

        const moveToEnd = (id: number): void => {
            const eventToMove = self.details.find(event => event.id === id);

            if (self.details.filter(event => event.order > eventToMove.order).length) {
                const eventToSwitch = self.details.filter(event => event.order > eventToMove.order).reduce((prev, current) => {
                    return (prev.order < current.order) ? prev : current
                });

                const auxOrder = eventToMove.order;
                eventToMove.order = eventToSwitch.order;
                eventToSwitch.order = auxOrder;
            }
        }

        const setLayoutColumns = (columnsCount: number): void => {
            self.layoutColumns = columnsCount;
        }

        return {
            initDetails,
            addEvent,
            removeEvent,
            moveToStart,
            moveToEnd,
            setLayoutColumns,
            removeAllFavoriteEvents
        };
    });

export const getEventDetailParamFromKey = (key: string): { eventId: number; categoryId?: string } => {
    let s = key.split('c');
    if (s.length === 1) {
        return {
            eventId: Number(s[0])
        };
    }

    return {
        eventId: Number(s[0]),
        categoryId: s[1]
    };
};

export type ILiveEventStore = Instance<typeof LiveEventStore>;